import requestWrapper from "../utils/requestWrapper";
import { IGenericResponse } from "@/services/interfaces";
import { ICartParams } from "@/services/interfaces/requests";

export default async (params: ICartParams): Promise<IGenericResponse> => {
  const request = {
    url: `/api/cart/products/${params.id}`,
    method: "PATCH",
    data: params.data,
  };

  return await requestWrapper(request);
};
